import React from "react";
import { func, array } from "prop-types";

import CrossIcon from "../../atoms/icons/cross-icon";

import "./settingsView.m.css";

const SettingsView = ({ navigateToPage, closePopup }) => {
  const dashboardClick = () => {
    closePopup();
    navigateToPage("/dashboard");
  };

  return (
    <div styleName="wrapper">
      <div styleName="content-link-wrapper">
        <div styleName="settings-link" onClick={dashboardClick}>
          My Profile
        </div>
        {/**
          2nd Phase
          <Link styleName="settings-link" href="">
            Change Password
          </Link>
        */}
        <a styleName="settings-link" href="/contact-us">
          Contact Us
        </a>
        <a styleName="settings-link" href="/membership/faq">
          FAQs
        </a>
      </div>

      <div
        styleName="retry-subscription-btn"
        onClick={() => {
          closePopup();
          navigateToPage("/plan-selection");
        }}
      >
        Retry Subscription
      </div>

      <div styleName="cross-icon" onClick={closePopup}>
        <CrossIcon width={20} height={20} />
      </div>
    </div>
  );
};

SettingsView.propTypes = {
  navigateToPage: func,
  closePopup: func,
  myPlans: array,
};

export default SettingsView;
